<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <Vlog :type='type' :id='id'></Vlog>        
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Vlog from '@/components/vlog'

export default {
  data () {
    return {
      type:'edit',
      id: this.$route.query.id,
      navBlock: '新聞  /  Vlog',
      navtitle: '編輯Vlog'
    }
  },
  methods:{
  },
  components: {
    NavBar,
    Vlog
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/news/vlog/editVlog.vue